<navbar></navbar>

<main>
  <router-outlet></router-outlet>
</main>

<!-- Todo: Save accept-choice in local storage
<cookie-law-banner></cookie-law-banner>-->
